export const mapIcons = [
  {
    name: "bus",
    icon: "iconBus"
  },
  {
    name: "busGreen",
    icon: "iconBusGreen"
  },
  {
    name: "busBlue",
    icon: "iconBusBlue"
  },
  {
    name: "busError",
    icon: "iconBusError"
  },
  {
    name: "busActive",
    icon: "iconBusActive"
  },
  {
    name: "camera",
    icon: "iconCamera"
  },
  {
    name: "cameraActive",
    icon: "iconCameraActive"
  },
  {
    name: "cameraError",
    icon: "iconCameraError"
  },
  {
    name: "cameraWork",
    icon: "iconCameraWork"
  },
  {
    name: "cameraInactive",
    icon: "iconCameraInactive"
  },
  {
    name: "detectors",
    icon: "iconDetectors"
  },
  {
    name: "irDetectors",
    icon: "iconIkDetectors"
  },
  {
    name: "trafficLights",
    icon: "iconTrafficLights"
  },
  {
    name: "trafficLightsActive",
    icon: "iconTrafficLightsActive"
  },
  {
    name: "trafficLightsError",
    icon: "iconTrafficLightsError"
  },
  {
    name: "trafficLightsWork",
    icon: "iconTrafficLightsWork"
  },
  {
    name: "streetLightActive",
    icon: "iconStreetLightActive"
  },
  {
    name: "streetLightError",
    icon: "iconStreetLightError"
  },
  {
    name: "streetLightWork",
    icon: "iconStreetLightWork"
  },
  {
    name: "meteostation",
    icon: "iconMeteostation"
  },
  {
    name: "meteostationActive",
    icon: "iconMeteostationActive"
  },
  {
    name: "meteostationError",
    icon: "iconMeteostationError"
  },
  {
    name: "meteostationWork",
    icon: "iconMeteostationWork"
  },
  {
    name: "tlt7",
    icon: "iconTlt7"
  },
  {
    name: "tlt7Active",
    icon: "iconTlt7Active"
  },
  {
    name: "roadWorks",
    icon: "iconRoadWorks"
  },
  {
    name: "events",
    icon: "iconEvents"
  },
  {
    name: "accident",
    icon: "iconAccident"
  },
  {
    name: "tram",
    icon: "iconTram"
  },
  {
    name: "tramActive",
    icon: "iconTramActive"
  },
  {
    name: "trolleybus",
    icon: "iconTrolleybus"
  },
  {
    name: "trolleybusActive",
    icon: "iconTrolleybusActive"
  },
  {
    name: "bulldozer",
    icon: "iconBulldozer"
  },
  {
    name: "bulldozerActive",
    icon: "iconBulldozerActive"
  },
  {
    name: "bulldozerRed",
    icon: "iconBulldozerRed"
  },
  {
    name: "bulldozerBlue",
    icon: "iconBulldozerBlue"
  },
  {
    name: "bulldozerGreen",
    icon: "iconBulldozerGreen"
  },
  {
    name: "bulldozerBrown",
    icon: "iconBulldozerBrown"
  },
  {
    name: "mtaxi",
    icon: "iconMtaxi"
  },
  {
    name: "mtaxiActive",
    icon: "iconMtaxiActive"
  },
  {
    name: "trafficCone",
    icon: "iconTrafficConeRed"
  },
  {
    name: "trafficConeActive",
    icon: "iconTrafficConeActive"
  },
  {
    name: "roadWork",
    icon: "iconRoadWork"
  },
  {
    name: "roadWorkActive",
    icon: "iconRoadWorkActive"
  },
  {
    name: "roadEvent",
    icon: "iconRoadEvent"
  },
  {
    name: "roadEventActive",
    icon: "iconRoadEventActive"
  },
  {
    name: "roadAccident",
    icon: "iconRoadAccident"
  },
  {
    name: "roadAccidentActive",
    icon: "iconRoadAccidentActive"
  },
  {
    name: "car",
    icon: "iconCar"
  },
  {
    name: "carActive",
    icon: "iconCarActive"
  }
];
